module.exports = __webpack_public_path__ + "static/LEPA-Dienstleistungen-AGB-2015-43108394d8da90de0833f7123a606c50.pdf";